import { Component, input } from '@angular/core';
import type { AgentCounts } from '../../domain/agent-counts';
import { twoDigits } from '../../domain/format';

// Etat de la partie : statut global, texte projete, compteurs d'agents.
// En lobby, un seul compteur (personne ne peut y etre elimine).
@Component({
  selector: 'app-game-status',
  styleUrl: './game-status.scss',
  templateUrl: './game-status.html',
})
export class GameStatus {
  readonly status = input.required<string>();
  readonly counts = input.required<AgentCounts>();
  readonly lobby = input(false);
  readonly done = input(false);

  protected readonly digits = twoDigits;
}
